import { render, staticRenderFns } from "./WorkflowTab.vue?vue&type=template&id=c3d22f22&scoped=true"
import script from "./WorkflowTab.vue?vue&type=script&lang=js"
export * from "./WorkflowTab.vue?vue&type=script&lang=js"
import style0 from "./WorkflowTab.vue?vue&type=style&index=0&id=c3d22f22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d22f22",
  null
  
)

export default component.exports